const MENU_LABELS = {
  'Toggle strong style': 'SLASH_COMMANDS.BOLD',
  'Toggle emphasis': 'SLASH_COMMANDS.ITALIC',
  'Toggle code font': 'SLASH_COMMANDS.CODE',
  'Toggle strikethrough': 'SLASH_COMMANDS.STRIKETHROUGH',
  'Wrap in bullet list': 'SLASH_COMMANDS.BULLET_LIST',
  'Wrap in ordered list': 'SLASH_COMMANDS.ORDERED_LIST',
  'Add or remove link': 'EDITOR_TOOLBAR.LINK',
  'Undo last change': 'EDITOR_TOOLBAR.UNDO',
  'Redo last undone change': 'EDITOR_TOOLBAR.REDO',
  'Upload image': 'SLASH_COMMANDS.IMAGE',
  'Insert table': 'SLASH_COMMANDS.TABLE',
  'Heading 1': 'SLASH_COMMANDS.HEADING_1',
  'Heading 2': 'SLASH_COMMANDS.HEADING_2',
  'Heading 3': 'SLASH_COMMANDS.HEADING_3',
};

export const translateEditorMenu = (text, t) =>
  MENU_LABELS[text] ? t(MENU_LABELS[text]) : text;

export const enhanceEditorMenu = (
  view,
  { label, isDisabled, toggleLabels = [], linkLabel, onLink }
) => {
  const menu = view.dom
    .closest('.ProseMirror-menubar-wrapper')
    ?.querySelector('.ProseMirror-menubar');
  if (!menu) return undefined;
  menu.setAttribute('role', 'group');
  menu.setAttribute('aria-label', label);
  const update = () => {
    menu.querySelectorAll('.ProseMirror-icon').forEach(item => {
      const disabled =
        isDisabled() || item.classList.contains('ProseMirror-menu-disabled');
      item.setAttribute('role', 'button');
      item.setAttribute('aria-label', item.title);
      item.setAttribute('aria-disabled', String(disabled));
      if (toggleLabels.includes(item.title)) {
        item.setAttribute(
          'aria-pressed',
          String(item.classList.contains('ProseMirror-menu-active'))
        );
      }
      item.tabIndex = disabled ? -1 : 0;
    });
  };
  const onKeydown = event => {
    const item = event.target.closest('.ProseMirror-icon');
    if (!item || !menu.contains(item) || !['Enter', ' '].includes(event.key))
      return;
    event.preventDefault();
    event.stopPropagation();
    if (isDisabled() || item.classList.contains('ProseMirror-menu-disabled'))
      return;
    item.dispatchEvent(
      new MouseEvent('mousedown', { bubbles: true, cancelable: true })
    );
    if (!onLink || item.title !== linkLabel) view.focus();
  };
  const onMousedown = event => {
    const item = event.target.closest('.ProseMirror-icon');
    if (!onLink || !item || item.title !== linkLabel) return;
    event.preventDefault();
    event.stopPropagation();
    if (!isDisabled() && !item.classList.contains('ProseMirror-menu-disabled'))
      onLink();
  };
  menu.addEventListener('mousedown', onMousedown, true);
  menu.addEventListener('keydown', onKeydown);
  const observer = new MutationObserver(update);
  observer.observe(menu, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'title'],
  });
  update();
  return {
    update,
    destroy() {
      observer.disconnect();
      menu.removeEventListener('keydown', onKeydown);
      menu.removeEventListener('mousedown', onMousedown, true);
    },
  };
};
